export const formatDateTime = (iso) => {
  if (!iso) return "—";
  return new Date(iso).toLocaleString("en-US", {
    dateStyle: "medium",
    timeStyle: "short",
  });
};

export const formatCount = (n) =>
  typeof n === "number" ? n.toLocaleString("en-US") : "—";

// Comma/newline separated text <-> allowedDomains array.
export const parseDomains = (text) =>
  text
    .split(/[\s,]+/)
    .map((d) => d.trim())
    .filter(Boolean);

export const domainsToText = (domains) => (domains ?? []).join("\n");
